<mat-form-field [appearance]="appearance" [ngClass]="{ 'form-field-without-padding': isInToolbar }" class="{{ formFieldClass }}">
  <mat-label>{{ label || placeholder }}</mat-label>
  <input matInput [formControl]="formControl" [placeholder]="placeholder" />
  @if (hasSearchIcon) {
  <mat-icon matSuffix>search</mat-icon>
  } @if (hasCancelButton && formControl.value) {
  <button mat-button mat-icon-button matSuffix (click)="clearSearchField()">
    <mat-icon>close</mat-icon>
  </button>
  }
</mat-form-field>
